.Page {
  display: flex;
  flex-direction: column;
  gap: var(--rv-space-4);
  padding-block: var(--rv-space-4);
}

.Title {
  margin: 0;
  font-size: var(--rv-text-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--content-foundation-content-primary);
}

.Subtitle {
  margin: var(--rv-space-1) 0 0;
  max-width: var(--container-width-md);
  font-size: var(--rv-text-sm);
  color: var(--content-foundation-content-secondary);
}

.Card {
  display: flex;
  flex-direction: column;
  gap: var(--rv-space-3);
  padding: var(--rv-space-4);
  border: var(--space-3xs) solid var(--border-foundation-border-primary);
  border-radius: var(--rv-radius-md);
}

.SectionTitle {
  margin: 0;
  font-size: var(--rv-text-xs);
  font-weight: var(--font-weight-semibold);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--content-foundation-content-tertiary);
}

.Row {
  display: flex;
  align-items: flex-end;
  gap: var(--rv-space-3);
  flex-wrap: wrap;
}

.Field {
  flex: 0 0 12rem;
}

.CheckRow {
  display: flex;
  align-items: center;
  gap: var(--rv-space-2);
}

.Hint {
  margin: 0;
  font-size: var(--rv-text-xs);
  color: var(--content-foundation-content-tertiary);
}

.Stats {
  display: flex;
  flex-wrap: wrap;
  gap: var(--rv-space-4);
}

.Stat {
  display: flex;
  flex-direction: column;
  min-width: var(--space-10xl);
}

.StatValue {
  font-size: var(--rv-text-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--content-foundation-content-primary);
  font-variant-numeric: tabular-nums;
}

.StatLabel {
  font-size: var(--rv-text-xs);
  color: var(--content-foundation-content-tertiary);
}

.Reached {
  color: var(--content-foundation-content-accent-a);
}

.Reason {
  font-size: var(--rv-text-xs);
  color: var(--content-foundation-content-tertiary);
}

.Muted {
  color: var(--content-foundation-content-tertiary);
}
